import { Link } from 'react-router-dom';

/**
 * TermsPage - Public terms of service
 */
export function TermsPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-forest-900 via-forest-800 to-forest-950">
      {/* Header */}
      <header className="px-6 py-4 flex items-center justify-between max-w-6xl mx-auto">
        <Link to="/welcome" className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-primary-500 to-primary-600 shadow-glow flex items-center justify-center">
            <span className="text-xl">🌿</span>
          </div>
          <span className="font-display text-xl font-semibold text-white">The Wright Gardner</span>
        </Link>
      </header>

      {/* Content */}
      <main className="px-6 py-12 max-w-3xl mx-auto">
        <div className="bg-white rounded-2xl p-8 shadow-xl">
          <h1 className="font-display text-3xl font-bold text-forest-900 mb-6">Terms of Service</h1>
          <p className="text-sage-600 mb-4">Last updated: {new Date().toLocaleDateString('en-US', { timeZone: 'America/Los_Angeles' })}</p>

          <div className="prose prose-sage max-w-none">
            <h2 className="font-display text-xl font-semibold text-forest-800 mt-8 mb-4">1. Acceptance of Terms</h2>
            <p className="text-sage-700 mb-4">
              By accessing or using The Wright Gardner application, you agree to be bound by these
              Terms of Service. If you do not agree to these terms, please do not use our service.
            </p>

            <h2 className="font-display text-xl font-semibold text-forest-800 mt-8 mb-4">2. Description of Service</h2>
            <p className="text-sage-700 mb-4">
              The Wright Gardner provides a landscape management platform that helps businesses
              manage schedules, work orders, client relationships, and service delivery.
            </p>

            <h2 className="font-display text-xl font-semibold text-forest-800 mt-8 mb-4">3. User Accounts</h2>
            <p className="text-sage-700 mb-4">
              You are responsible for:
            </p>
            <ul className="list-disc pl-6 text-sage-700 mb-4 space-y-2">
              <li>Maintaining the confidentiality of your account credentials</li>
              <li>All activities that occur under your account</li>
              <li>Notifying us immediately of any unauthorized use</li>
            </ul>

            <h2 className="font-display text-xl font-semibold text-forest-800 mt-8 mb-4">4. Acceptable Use</h2>
            <p className="text-sage-700 mb-4">
              You agree not to:
            </p>
            <ul className="list-disc pl-6 text-sage-700 mb-4 space-y-2">
              <li>Use the service for any unlawful purpose</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Interfere with or disrupt the service</li>
              <li>Share your account with others</li>
            </ul>

            <h2 className="font-display text-xl font-semibold text-forest-800 mt-8 mb-4">5. Data Ownership</h2>
            <p className="text-sage-700 mb-4">
              You retain ownership of all data you input into the platform. We claim no ownership
              over your business data, client information, or service records.
            </p>

            <h2 className="font-display text-xl font-semibold text-forest-800 mt-8 mb-4">6. Service Availability</h2>
            <p className="text-sage-700 mb-4">
              We strive to maintain high availability but do not guarantee uninterrupted access.
              We may perform maintenance or updates that temporarily affect service availability.
            </p>

            <h2 className="font-display text-xl font-semibold text-forest-800 mt-8 mb-4">7. Limitation of Liability</h2>
            <p className="text-sage-700 mb-4">
              To the maximum extent permitted by law, The Wright Gardner shall not be liable for
              any indirect, incidental, special, or consequential damages arising from your use
              of the service.
            </p>

            <h2 className="font-display text-xl font-semibold text-forest-800 mt-8 mb-4">8. Changes to Terms</h2>
            <p className="text-sage-700 mb-4">
              We reserve the right to modify these terms at any time. Continued use of the service
              after changes constitutes acceptance of the new terms.
            </p>

            <h2 className="font-display text-xl font-semibold text-forest-800 mt-8 mb-4">9. Contact</h2>
            <p className="text-sage-700 mb-4">
              For questions about these terms, contact us at:
            </p>
            <p className="text-sage-700 mb-4">
              <strong>The Wright Gardner</strong><br />
              Email: legal@thewrightgardner.com
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="px-6 py-8">
        <div className="max-w-6xl mx-auto text-center">
          <Link to="/welcome" className="text-forest-400 hover:text-forest-200 text-sm transition-colors">
            ← Back to Home
          </Link>
        </div>
      </footer>
    </div>
  );
}
